import React from 'react';
import i18next from "../../i18n.js";
import { PasswordInput } from '../forms/PasswordInput.js';
import { unknownErrorMessageDialog, viewFolderSystemFile } from '../ModalDialog.js';
import AccountFormHeader from './AccountFormHeader.js';
import { isRequiredMessage, errorMessage } from "./AccountHelper.js";
import { backgroundTypes, urls } from '../../constants.js';
import { BackgroundContainer } from './BackgroundContaner.js';
import { Button, Form, Spinner } from 'react-bootstrap';
export class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            login: '',
            password: '',
            submitted: false,
            incorrectLogin: false,
            loading: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        localStorage.removeItem('user');
    }
    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value, incorrectLogin: false });
    }
    handleSubmit(e) {
        e.preventDefault();
        const { login, password, loading } = this.state;
        if (!loading) {
            if (login && password)
                this.logIn(login, password);
            else
                this.setState({ submitted: true });
        }
    }
    logIn(login, password) {
        localStorage.removeItem('user');
        this.setState({ loading: true });
        fetch('/api/account/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ login, password })
        })
            .then(async (response) => {
                let data = await response.json();
                if (response.ok && data) {
                    localStorage.setItem('user', JSON.stringify(data));

                    const urlParams = new URLSearchParams(document.location.search);
                    const returnParam = urlParams.get('return');
                    if (returnParam) {
                        window.location.replace(`${document.location.origin}${returnParam}`);
                    }
                    else {
                        window.location.replace("/");
                    }
                }
                else {
                    if (data?.error === 'userDoesNotExist') {
                        this.setState({ loading: false, incorrectLogin: true, submitted: true });
                    }
                    else {
                        unknownErrorMessageDialog();
                        this.setState({ loading: false });
                    }
                }
            })
            .catch((error) => {
                unknownErrorMessageDialog();
                this.setState({ loading: false });
            });
    }
    offerLinkClick(e) {
        e.preventDefault();
        e.stopPropagation();
        viewFolderSystemFile('/api/home/getOfferAgreementFileContent', i18next.t('offerAgreement'))
    }

    render() {
        const { login, password, submitted, incorrectLogin, loading } = this.state;
        return (
            <BackgroundContainer type={backgroundTypes.account}>
                <div className="form-page login-page">
                    <div className="form-block login-form">
                        <AccountFormHeader />
                        <div className="form-content">
                            <form name="form" onSubmit={this.handleSubmit} >
                                <div className={'form-group' + (submitted && !login ? ' has-error' : '')}>
                                    <Form.Control name="login" value={login} onChange={this.handleChange} placeholder={i18next.t("account.loginPlaceholder")} disabled={loading ? "disabled" : ""} />
                                    {isRequiredMessage(submitted && !login)}
                                </div>
                                <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                                    <PasswordInput className="form-control" name="password" value={password} onChange={this.handleChange} disabled={loading ? "disabled" : ""} />
                                    {isRequiredMessage(submitted && !password)}
                                    {errorMessage(submitted && incorrectLogin, 'failedLoginAttempt')}
                                </div>
                                <div className="form-group form-group__last">
                                    <Button type="submit" variant="primary">{loading && <Spinner animation="border" variant="primary" size="sm" />}{i18next.t("logIn")}</Button>
                                </div>
                            </form>
                        </div>
                        <div className="offer">
                            <div className="offer-content">
                                {i18next.t("account.offerLinkText")}&nbsp;<a className="offer-link" onClick={this.offerLinkClick} href="#" >{i18next.t("account.offerLinkTitle")}</a>&nbsp;{i18next.t("account.and")}&nbsp;<a className="offer-link" href={urls.privacyPage} target="_blank">{i18next.t("account.privacyLinkTitle")}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </BackgroundContainer>
        );
    }
}